"use client";

import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Header } from "../Components";
import axios from "axios";
import { useBaseUrl } from "../Contexts/BaseUrlContext";

const AdsRewardWalletAccount = () => {
  const { user_id } = useParams();
  const navigate = useNavigate();

  const [walletData, setWalletData] = useState(null);
  const [loading, setLoading] = useState(true);

  const { baseUrl } = useBaseUrl();

  const api = axios.create({
    baseURL: `${baseUrl}/`,
    withCredentials: true,
    headers: { "Content-Type": "multipart/form-data" },
  });

  const fetchWalletData = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("action", "getAdsWalletData");
      formData.append("user_id", user_id);

      const res = await api.post("/wallet.php", formData);

      if (res.data.status) {
        setWalletData(res.data.data);
      }
    } catch (err) {
      console.error("API Error:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (user_id) {
      fetchWalletData();
    }
  }, [user_id]);

  const getTransactionIcon = (type) => {
    return type === "credit" ? "pi pi-arrow-down" : "pi pi-arrow-up";
  };

  const getTransactionColor = (type) => {
    return type === "credit" ? "text-green-600" : "text-red-600";
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <i className="pi pi-spin pi-spinner text-4xl text-blue-500"></i>
      </div>
    );
  }

  if (!walletData) {
    return (
      <div className="max-w-7xl mx-auto p-6">
        <Header category="Finance" title="Ads Reward Wallet Account" />
        <div className="text-center p-8">No data found</div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto p-6">
      <div className="flex items-center gap-4 mb-6">
        <Button
          icon="pi pi-arrow-left"
          className="p-button-text"
          onClick={() => navigate(-1)}
        />
        <Header category="Finance" title="Ads Reward Wallet Account" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white dark:bg-secondary-dark-bg rounded-xl shadow-lg p-6">
          <h3 className="text-lg font-semibold mb-4">User Details</h3>
          <div className="flex items-center gap-4 mb-4">
            <img
              src={walletData.user.profile_img || "https://via.placeholder.com/80"}
              alt="Profile"
              className="w-20 h-20 rounded-full object-cover"
            />
            <div>
              <p className="text-xl font-semibold">{walletData.user.name}</p>
              <p className="text-gray-500">ID: {walletData.user.user_id}</p>
            </div>
          </div>
          <div className="space-y-2">
            <p className="flex items-center gap-2">
              <i className="pi pi-envelope text-gray-400"></i>
              <span className="text-gray-600 dark:text-gray-300">{walletData.user.email_id}</span>
            </p>
            <p className="flex items-center gap-2">
              <i className="pi pi-phone text-gray-400"></i>
              <span className="text-gray-600 dark:text-gray-300">{walletData.user.phone_num}</span>
            </p>
          </div>
        </div>

        <div className="bg-white dark:bg-secondary-dark-bg rounded-xl shadow-lg p-6">
          <h3 className="text-lg font-semibold mb-4">Wallet Balance</h3>
          <div className="text-center py-4">
            <p className="text-4xl font-bold text-green-600">
              ₹{Number(walletData.wallet.wallet_balance).toLocaleString()}
            </p>
            <p className="text-gray-500 mt-2">
              Hold Balance: ₹{Number(walletData.wallet.hold_balance).toLocaleString()}
            </p>
            <p className="text-gray-500 mt-1">
              Last Updated: {walletData.wallet.last_update}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-6 bg-white dark:bg-secondary-dark-bg rounded-xl shadow-lg p-6">
        <h3 className="text-lg font-semibold mb-4">Transactions</h3>
        {walletData.transactions && walletData.transactions.length > 0 ? (
          <div className="space-y-3">
            {walletData.transactions.map((transaction) => (
              <div
                key={transaction.tnx_id}
                className="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 rounded-lg"
              >
                <div className="flex items-center gap-4">
                  <div className={`p-3 rounded-full ${getTransactionColor(transaction.type)} bg-opacity-10`}>
                    <i className={`pi ${getTransactionIcon(transaction.type)} text-xl`}></i>
                  </div>
                  <div>
                    <p className="font-semibold capitalize">{transaction.type}</p>
                    <p className="text-sm text-gray-500">{transaction.description}</p>
                    <p className="text-xs text-gray-400">{transaction.date_time}</p>
                  </div>
                </div>
                <div className={`text-xl font-bold ${getTransactionColor(transaction.type)}`}>
                  {transaction.type === "credit" ? "+" : "-"}₹{Number(transaction.coin).toLocaleString()}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-8 text-gray-500">No transactions found</div>
        )}
      </div>
    </div>
  );
};

export default AdsRewardWalletAccount;
